import { api, handleError } from "./baseApi";

export async function getReferralData(params = {}) {
  try {
    Object.keys(params).forEach((key) => {
      if (!params[key]) delete params[key];
    });

    const { data } = await api.get("/referral", { params });
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch referral data");
  }
}

export async function getReferralByCode(referralCode) {
  try {
    const { data } = await api.get(`/referral/code/${referralCode}`);
    return data;
  } catch (error) {
    return handleError(error, "Failed to fetch referral by code");
  }
}
